import React from 'react';
import { PencilAltIcon } from '@heroicons/react/solid';
import { Collapse } from '@mantine/core';
import ReserveFieldDescription from '@/components/reserve/ReserveFieldDescription/ReserveFieldDescription';
import { useReserveForm } from '@/components/reserve/Reserve/ReserveFormProvider';

export const ReserveFormMeetingRoomNotes: React.FC = () => {
  const { isMeetingRoom, form } = useReserveForm();
  const [notesOpened, setNotesOpened] = React.useState(false);

  if (!isMeetingRoom) return null;

  return (
    <div className="mt-3 mb-2">
      <button
        className="flex items-center pb-2 text-secondary [.tactic-v2_&]:text-secondary-foreground"
        onClick={(e) => {
          e.preventDefault();
          setNotesOpened((s) => !s);
        }}
      >
        <PencilAltIcon className="mr-1.5 h-4 w-4" />
        Add meeting notes
      </button>
      <Collapse in={notesOpened}>
        <ReserveFieldDescription form={form} />
      </Collapse>
    </div>
  );
};
